import script from "./GiftDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./GiftDialog.vue?vue&type=script&setup=true&lang=js"

import "./GiftDialog.vue?vue&type=style&index=0&id=28b5601c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b5601c"]])

export default __exports__